import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ILanguageState } from '../interfaces/ILanguageState';

const language: string | null = localStorage.getItem('language');

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
		value: language === null ? "EN" : language // Sets default language to be english for first time visitors.
	} as ILanguageState,
  reducers: {
    changeLanguage: (state: ILanguageState, action: PayloadAction<string>) => {
      state.value = action.payload
    },
  },
});

export const { changeLanguage } = languageSlice.actions
export default languageSlice.reducer